import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompanyTypes = (props) => /* @__PURE__ */ _jsxs("svg", {
	name: "company-types",
	viewBox: "0 0 304 80",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
		id: "a",
		d: "M5.58333 4.84766c.0612.0612.0612.16015 0 .22135l-.51562.51432c-.0612.0612-.16016.0612-.22136 0L4 4.72917l-.84766.85416c-.0612.0612-.16015.0612-.22135 0l-.51432-.51562c-.0612-.0612-.0612-.16016 0-.22136L3.27083 4l-.85416-.84766c-.0612-.0612-.0612-.16015 0-.22135l.51562-.51563c.0612-.0612.16016-.0612.22136 0L4 3.27083l.84766-.85416c.0612-.0612.16015-.0612.22135 0l.51563.51562c.0612.0612.0612.16016 0 .22136L4.72917 4l.85416.84766z"
	}) }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				className: "shadow",
				fill: "#483D9F",
				filter: "url(#a)",
				x: 74,
				y: 16,
				width: 64,
				height: 64,
				rx: 4
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .4,
				transform: "translate(0 16)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						width: 64,
						height: 64,
						fill: "#FFF",
						fillRule: "nonzero",
						rx: 4
					}),
					/* @__PURE__ */ _jsx("path", { d: "M20 20h24v24H20z" }),
					/* @__PURE__ */ _jsx("path", {
						fill: "#5649BE",
						fillRule: "nonzero",
						d: "M42.5625 24.6H38.5v-2.3c0-1.2698-1.0918-2.3-2.4375-2.3h-8.125C26.5918 20 25.5 21.0302 25.5 22.3v2.3h-4.0625C20.0918 24.6 19 25.6302 19 26.9v13.8c0 1.2698 1.0918 2.3 2.4375 2.3h21.125C43.9082 43 45 41.9698 45 40.7V26.9c0-1.2698-1.0918-2.3-2.4375-2.3zM28.75 23.06667h6.5V24.6h-6.5v-1.53333zM36.875 34.95c0 .21083-.18281.38333-.40625.38333H33.625v2.68334c0 .21083-.18281.38333-.40625.38333h-2.4375c-.22344 0-.40625-.1725-.40625-.38333v-2.68334h-2.84375c-.22344 0-.40625-.1725-.40625-.38333v-2.3c0-.21083.18281-.38333.40625-.38333H30.375v-2.68334c0-.21083.18281-.38333.40625-.38333h2.4375c.22344 0 .40625.1725.40625.38333v2.68334h2.84375c.22344 0 .40625.1725.40625.38333v2.3z"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				className: "slide-up",
				transform: "translate(80)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						width: 64,
						height: 64,
						fill: "#FFF",
						fillRule: "nonzero",
						rx: 4
					}),
					/* @__PURE__ */ _jsx("path", { d: "M20 20h24v24H20z" }),
					/* @__PURE__ */ _jsx("path", {
						fill: "#483D9F",
						fillRule: "nonzero",
						d: "M34.875 35.60714c0 .45384-.37758.82143-.84375.82143h-5.0625c-.46617 0-.84375-.36759-.84375-.82143v-2.46428H18v7.39285C18 41.85 19.18125 43 20.53125 43h21.9375C43.81875 43 45 41.85 45 40.53571v-7.39285H34.875v2.46428zm7.59375-10.67857H38.25V22.4643C38.25 21.15 37.06875 20 35.71875 20h-8.4375c-1.35 0-2.53125 1.15-2.53125 2.46429v2.46428h-4.21875c-1.35 0-2.53125 1.15-2.53125 2.46429V31.5h27v-4.10714c0-1.31429-1.18125-2.46429-2.53125-2.46429zm-7.59375 0h-6.75v-1.64286h6.75v1.64286z"
					}),
					/* @__PURE__ */ _jsxs("g", {
						transform: "translate(36 34)",
						children: [
							/* @__PURE__ */ _jsx("circle", {
								cx: 4,
								cy: 4,
								r: 4,
								fill: "#FFF",
								stroke: "#483D9F"
							}),
							/* @__PURE__ */ _jsx("path", { d: "M.8.8h6v6h-6z" }),
							/* @__PURE__ */ _jsx("path", {
								fill: "#5649BE",
								fillRule: "nonzero",
								d: "M5.55495 4.6093a1.07545 1.07545 0 0 0-.10798-.23927c-.04898-.07505-.11038-.14202-.18182-.1983a2.14903 2.14903 0 0 0-.21247-.1563 2.1371 2.1371 0 0 0-.25887-.13262 4.87043 4.87043 0 0 0-.26073-.10946c-.06398-.02392-.1565-.05676-.2778-.0985-.10743-.03743-.18741-.0662-.23993-.0858a5.5644 5.5644 0 0 1-.20768-.0845 1.24816 1.24816 0 0 1-.19195-.09673 1.48693 1.48693 0 0 1-.13543-.1031c-.04799-.04073-.08185-.084-.1013-.12982a.38085.38085 0 0 1-.02933-.15019c0-.14153.06878-.2571.20608-.3467.13703-.0896.31431-.1344.53159-.1344.09597 0 .19382.01196.29326.03614.09917.02393.18448.05091.2554.0812a1.78448 1.78448 0 0 1 .20048.10005c.06291.0364.1077.06389.13383.08273.0264.01883.04292.0313.04985.03741.02986.02088.06052.028.09251.0219.03382-.00177.064-.02085.07891-.0499l.2778-.45641c.02746-.0415.02186-.0812-.01706-.11862a1.1785 1.1785 0 0 0-.05146-.04379 1.78277 1.78277 0 0 0-.13383-.09062 1.69852 1.69852 0 0 0-.2178-.1171 2.33407 2.33407 0 0 0-.2986-.10487 2.06649 2.06649 0 0 0-.37856-.07178V1.3001c.00091-.02712-.01034-.05333-.03093-.07204-.02137-.01897-.04976-.02904-.07891-.028h-.46308c-.02887-.00042-.05671.01021-.07731.02953-.02081.01794-.03264.0435-.03253.07026v.56256c-.35884.06237-.6505.20212-.87444.41874-.22394.21663-.3359.46863-.3359.75603 0 .08553.00959.16698.02905.24386.01946.07713.04346.14637.07198.20797.02853.06135.06932.12193.12184.18124.05252.05931.1021.11048.1493.15299.04665.04276.1077.08705.18314.13287.07545.04582.14023.08299.19382.11099.05385.028.1253.06033.21434.09673.08931.03665.1597.06415.21115.08298.05118.01859.12157.0448.2106.0779.1237.04378.21515.07764.2746.10182.05945.02393.1349.05727.22661.09978.09118.04277.1581.08171.20048.1171.04212.03564.08051.07942.11464.13135.03466.05218.05172.10742.05172.16546 0 .16495-.07038.29197-.21088.38132-.14076.0896-.30392.1344-.48894.1344a1.29701 1.29701 0 0 1-.25353-.02494c-.29726-.05422-.57505-.1843-.83338-.39049l-.00694-.00636c-.02021-.02276-.05164-.03344-.08237-.028-.03653.00407-.06292.01654-.07892.03742l-.35324.42205c-.03412.04149-.03199.084.00693.12804.01147.01247.03146.0313.05999.056.02852.02545.08184.0644.15942.1176a2.3405 2.3405 0 0 0 .2538.14993c.09145.04684.20768.09317.34818.13899.14076.04582.28632.07815.43722.09673v.54703c0 .02699.01093.0504.03279.07026.02049.01935.04823.03007.07705.02978h.46307c.032 0 .05839-.00941.07892-.028.02052-.01873.03167-.04494.03066-.07204v-.54703c.36363-.05397.65929-.19626.8867-.42638.2274-.23037.34124-.50478.34124-.82348 0-.10436-.01493-.20211-.04505-.29375z"
							})
						]
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .4,
				transform: "translate(160 16)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						width: 64,
						height: 64,
						fill: "#FFF",
						fillRule: "nonzero",
						rx: 4
					}),
					/* @__PURE__ */ _jsx("path", { d: "M20 20h24v24H20z" }),
					/* @__PURE__ */ _jsx("path", {
						fill: "#5649BE",
						fillRule: "nonzero",
						d: "M35.875 35.60714c0 .45384-.37758.82143-.84375.82143h-5.0625c-.46617 0-.84375-.36759-.84375-.82143v-2.46428H19v7.39285C19 41.85 20.18125 43 21.53125 43h21.9375C44.81875 43 46 41.85 46 40.53571v-7.39285H35.875v2.46428zm7.59375-10.67857H39.25V22.4643C39.25 21.15 38.06875 20 36.71875 20h-8.4375c-1.35 0-2.53125 1.15-2.53125 2.46429v2.46428h-4.21875c-1.35 0-2.53125 1.15-2.53125 2.46429V31.5h27v-4.10714c0-1.31429-1.18125-2.46429-2.53125-2.46429zm-7.59375 0h-6.75v-1.64286h6.75v1.64286z"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .4,
				transform: "translate(240 16)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						width: 64,
						height: 64,
						fill: "#FFF",
						fillRule: "nonzero",
						rx: 4
					}),
					/* @__PURE__ */ _jsx("path", { d: "M20 20h24v24H20z" }),
					/* @__PURE__ */ _jsx("path", {
						fill: "#5649BE",
						fillRule: "nonzero",
						d: "M34.875 35.60714c0 .45384-.37758.82143-.84375.82143h-5.0625c-.46617 0-.84375-.36759-.84375-.82143v-2.46428H18v7.39285C18 41.85 19.18125 43 20.53125 43h21.9375C43.81875 43 45 41.85 45 40.53571v-7.39285H34.875v2.46428zm7.59375-10.67857H38.25V22.4643C38.25 21.15 37.06875 20 35.71875 20h-8.4375c-1.35 0-2.53125 1.15-2.53125 2.46429v2.46428h-4.21875c-1.35 0-2.53125 1.15-2.53125 2.46429V31.5h27v-4.10714c0-1.31429-1.18125-2.46429-2.53125-2.46429zm-7.59375 0h-6.75v-1.64286h6.75v1.64286z"
					}),
					/* @__PURE__ */ _jsx("circle", {
						cx: 4,
						cy: 4,
						r: 4,
						fill: "#FFF",
						transform: "translate(36 34)"
					}),
					/* @__PURE__ */ _jsx("g", {
						transform: "translate(36 34)",
						children: /* @__PURE__ */ _jsx("use", {
							fill: "#5649BE",
							fillRule: "nonzero",
							xlinkHref: "#a"
						})
					})
				]
			})
		]
	})]
});
export default SvgCompanyTypes;
